import { Controller } from "@hotwired/stimulus"

/**
 * Voice Preview Controller
 *
 * Plays voice preview audio samples. Only one preview plays at a time
 * across the entire page — starting a new preview stops any playing one.
 */
export default class extends Controller {
  static targets = ["playIcon", "pauseIcon"]
  static values = { url: String }

  connect() {
    this.audio = null
    this.playing = false
    this.handleStopAll = () => this.stop()
    document.addEventListener("voice-preview:stop-all", this.handleStopAll)
  }

  disconnect() {
    this.stop()
    document.removeEventListener("voice-preview:stop-all", this.handleStopAll)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.playing) {
      this.stop()
    } else {
      // Stop any other playing preview first
      document.dispatchEvent(new CustomEvent("voice-preview:stop-all"))
      this.play()
    }
  }

  play() {
    if (!this.urlValue) return

    this.audio = new Audio(this.urlValue)
    this.audio.volume = 0.8
    this.audio.addEventListener("ended", () => this.stop())
    this.audio.play().catch(() => this.stop())
    this.playing = true
    this.updateIcons(true)
  }

  stop() {
    if (this.audio) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.audio = null
    }
    this.playing = false
    this.updateIcons(false)
  }

  updateIcons(isPlaying) {
    if (this.hasPlayIconTarget) {
      this.playIconTarget.classList.toggle("hidden", isPlaying)
    }
    if (this.hasPauseIconTarget) {
      this.pauseIconTarget.classList.toggle("hidden", !isPlaying)
    }
  }
}
